export default function BasicFormPopup ({title, closePopupFn, children, fullWidth = false, heightFit = false, description}) {

    return (
        <div className={`z-[75] fixed top-0 left-0 w-full h-full flex justify-center items-center px-[4%] lg:px-0`}>
            <div className="absolute top-0 left-0 w-full h-full bg-olaf-green-500/60"></div>
            <div className={`relative olafGrid ${heightFit ? 'h-fit' : 'h-[80%]'} overflow-y-auto bg-white px-4 py-5 rounded-tl-lg rounded-br-lg ${!fullWidth && '!max-w-md'}`}>
                <div className={'group'}>
                    <h2 className="text-lg lg:text-xl mb-4">
                        {title}
                        <div
                            className="absolute top-4 right-[4%] w-6 h-6 cursor-pointer"
                            onClick={closePopupFn}
                        >
                            <div className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 rotate-45 rounded-[1px]"></div>
                            <div className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 -rotate-45 rounded-[1px]"></div>
                        </div>
                    </h2>
                    <div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}